// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__au7el","col":"Table_col__1T6n7","fulfillmentStatus":"Table_fulfillmentStatus__Cfuaz","emailCol":"Table_emailCol__20UCT"};